import {Pagination} from '@app/core/models/pagination.model';
import {Shift} from '@app/core/models/shift.model';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';
import {Availability} from '@app/core/models/availability.model';

export enum LoadingMassActionState {
	NONE,
	REMOVING,
	APPROVING,
}

export interface IActionsState {
	isLoading: boolean;
	pagination: Pagination;
	shifts: Shift[];
	shiftRequests: Shift[];
	shiftSwapRequests: Shift[];
	shiftRequestsPagination: IQOPagination;
	loadingMassActionState: LoadingMassActionState;
}

export const initialActionsState: IActionsState = {
	isLoading: false,
	shifts: [],
	pagination: undefined,
	shiftRequests: [],
	shiftSwapRequests: [],
	shiftRequestsPagination: null,
	loadingMassActionState: LoadingMassActionState.NONE,
};
